import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { Component } from 'react';

import { selectMaintenanceGuides } from '../../store/selectors/faqsNotesDocuments';
import MaintenanceGuides from '../../components/MaintenanceGuides';
import { fetchFaqsNotesDocuments, saveFaqsNotesDocuments, updateFaqsNotesDocuments, deleteFaqsNotesDocuments } from '../../store/actions/faqsNotesDocuments';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import { setSearch, clearSearch } from '../../store/actions/search';
import { fetchMaintainanceGuideBySuiteId } from '../../store/actions/suites';
import { selectPRLoader } from '../../store/selectors/PropertyLoader';
import Loader from '../../components/Loader';

class SuiteMaintainenceGuide extends Component {
    componentDidMount() {
        const { clearSearch, onFetchSuiteMaintainanceGuideBySuiteId, suite } = this.props;
        onFetchSuiteMaintainanceGuideBySuiteId(suite.id)
        clearSearch()
    }
    render() {
        const { maintenanceguides, item, onDeleteFaqsNotesDocuments, setSearch, loader } = this.props;
        return (
            loader ? <Loader /> :
            <MaintenanceGuides
                maintenanceguides={maintenanceguides}
                onlyView={true}
                onSearch={e => setSearch({ maintenanceguide: e.target.value.trim() })}
                introContent={true}
            />
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    maintenanceguides: selectMaintenanceGuides(state),
    user: selectAuthenticatedUser(state),
    loader: selectPRLoader(state),

});

const mapDispatchToProps = dispatch => bindActionCreators({
    setSearch,
    clearSearch,
    onFetchSuiteMaintainanceGuideBySuiteId:fetchMaintainanceGuideBySuiteId
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SuiteMaintainenceGuide);
